<div appAccessProvider [accessCode]="{ menuCode: 'SPONSORS', pageCode: 'ALL', subPageCode: 'VIEW' }">
  <div class="grid mt-2 mx-3 mr-0">
    <div class="flex justify-content-between col-12 bg-white btn-with-links p-3">
        <label class="category-name" translate>sponsor.lbl_users</label>
        <p-button class="flex align-items-center justify-content-center" icon="pi pi-plus" [label]="btnLabel" (click)="showAddDialog = !showAddDialog"></p-button>
    </div>
  </div>
</div>

  <div appAccessProvider [accessCode]="{ menuCode: 'SPONSORS', pageCode: 'ALL', subPageCode: 'VIEW' }">
    <div class="mx-3">
      @if(allColumns.length > 0) {
      <app-mi-table
                class="w-full"
                [collectionOfColumns]="allColumns"
                [attributeLabels]="filterAttributeLabels"
                [data]="tableData"
                [isLoading]="isLoading"
                (onPageChange)="onPageChange($event)"
                (itemPerPageChange)="itemPerPageChange($event)"
                [message]="deleteRoleMsg"
                [header]="deleteRoleHeaderMsg"
                [filterList]="filterList"
                (onValueChange)="onFilterValueChange($event)"
                [filterFields]="filterFieldsArray"
                [label]="btnLabel"
                (onBtnClick)="onAddUser()"
                [attributeData]="attributeData"
                [rowItems]="rowItems"
                (onUpdate)="onUpdateUser($event)"
                [bulkSelectionsItems] = "bulkSelectionsItems"
                [bulkUpdateLabel]="bulkUpdateLabel"
                [bulkUpdateHeader]="bulkUpdateHeader"
                [entityNameToDisplay]="entityNameToDisplay"
                [btnUpdate]="btnUpdate"
                [bulkDeleteLabel]="bulkDeleteLabel"
                (setCurrentRowData)="setCurrentRowData($event)"
                [showBulkUpdateDialog]="showBulkUpdateDialog"
                [reviewHeader]="reviewHeader"
                (onSearchValueChange)="onSearchValueChanges($event)"
                [totalRecords]="totalRecords"
                [visible]="visible"
                (onToggleOverLay)="showBulkUpdateDialog = false"
                (onChangeStatus)="onChangeStatus($event)"
                [isEntity]="isEntity"
                [uniqueId]="uniqueId"
                [staticEntity]="'user'"
                (onSortData)="onSortData($event)"
                >
              </app-mi-table>
      }
    </div>
  </div>

@if (showAddDialog) {
<ng-container>
      <app-add-sponsor-user (closePopup)="hidePopup($event)" (saveSuccess)="saveSuccessEvent()" [userId]="userId" [sponsorId]="sponsorId"/>
</ng-container>
}
